import { ButtonBase } from '@mui/material';
import { withStyles } from 'tss-react/mui';

export const Tile = withStyles(ButtonBase, (theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		background: theme.palette.background.paper,
		textAlign: 'left',
		borderRadius: 4,
		transition: 'box-shadow 0.3s ease-in-out',
		boxShadow: '0px 4px 16px rgba(0, 0, 0, 0)',
		'&:hover': {
			boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)'
		},
		padding: '22px 25px',
		[theme.breakpoints.up('sm')]: {
			padding: '20px 20px'
		},
		[theme.breakpoints.up('md')]: {
			padding: '25px 16px'
		},
		[theme.breakpoints.up('lg')]: {
			padding: '20px 25px'
		},
		[theme.breakpoints.up('xl')]: {
			padding: '24px 24px'
		}
	}
}));
